import type { TShipmentResponse } from "../models/shipment";
import type { TShipment } from "../shipmentTypes";

const mapShipmentResponse = (response: TShipmentResponse): TShipment => ({
  id: response.id,
  invoice: {
    privateName: response.invoice.privateName,
    privateEmail: response.invoice.privateEmail,
    companyName: response.invoice.companyName,
    registryCode: response.invoice.registryCode,
    emailAddress: response.invoice.emailAddress,
    vatNumber: response.invoice.vatNumber,
    companyRegistrationAddress: response.invoice.companyRegistrationAddress,
  },
  senderAddress: {
    name: response.senderAddress.name,
    contactName: response.senderAddress.contactName,
    contactEmail: response.senderAddress.contactEmail,
    contactPhone: response.senderAddress.contactPhone,
    contactInfo: response.senderAddress.contactInfo,
    email: response.senderAddress.email,
    phone: response.senderAddress.phone,
    street: response.senderAddress.street,
    streetNo: response.senderAddress.streetNo,
    flatNo: response.senderAddress.flatNo,
    city: response.senderAddress.city,
    postalCode: response.senderAddress.postalCode,
    country: response.senderAddress.country,
    countryCode: response.senderAddress.countryCode,
    pudoId: response.senderAddress.pudoId,
    lockerName: response.senderAddress.lockerName,
  },
  receiverAddress: {
    addressId: response.receiverAddress.addressId,
    name: response.receiverAddress.name,
    contactInfo: response.receiverAddress.contactInfo,
    email: response.receiverAddress.email,
    phone: response.receiverAddress.phone,
    street: response.receiverAddress.street,
    streetNo: response.receiverAddress.streetNo,
    flatNo: response.receiverAddress.flatNo,
    city: response.receiverAddress.city,
    postalCode: response.receiverAddress.postalCode,
    country: response.receiverAddress.country,
    countryCode: response.receiverAddress.countryCode,
    pudoId: response.receiverAddress.pudoId,
    lockerName: response.receiverAddress.lockerName,
  },
  willCustomerPrintLabel: response.willCustomerPrintLabel,
  offerGroupId: response.offerGroupId,
  coupon: response.coupon,
  pickup: response.pickup
    ? {
        pickupDate: response.pickup.pickupDate,
        pickupTimeFrom: response.pickup.pickupTimeFrom,
        pickupTimeTo: response.pickup.pickupTimeTo,
      }
    : null,
  affiliateGuid: response.affiliateGuid,
  dimension: response.dimension,
  deliveryMethod: response.deliveryMethod,
  price: response.price,
  originalPrice: response.originalPrice,
  parcelWeight: response.parcelWeight,
});
export default mapShipmentResponse;
